import type { Digimon } from "../types/common";
import 가루몬 from "../assets/images/가루몬.jpeg";
import 가트몬 from "../assets/images/가트몬.png";
import 도베르몬 from "../assets/images/도베르몬.jpeg";
import 레나몬 from "../assets/images/레나몬.jpeg";
import 쉬라몬 from "../assets/images/쉬라몬.png";
import 아구몬 from "../assets/images/아구몬.png";
import 에테몬 from "../assets/images/에테몬.jpeg";
import 코로몬 from "../assets/images/코로몬.jpeg";
import 테리어몬 from "../assets/images/테리어몬.jpeg";
import 토코몬 from "../assets/images/토코몬.webp";
import 파닥몬 from "../assets/images/파닥몬.jpeg";
import 플롯트몬 from "../assets/images/플롯트몬.png";
import 피요몬 from "../assets/images/피요몬.jpeg";
import Swal from "sweetalert2";

function getBase64(file: File): Promise<any> {
  return new Promise((resolve) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  });
}

function sleep(ms: number) {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

const getDigimonInfo = (digimonName: Digimon) => {
  const obj = {
    가루몬: {
      title: "가루몬",
      desc: "파피몬이 진화한 성숙기의 짐승형 디지몬.\n늑대의 형상을 하고 있으며, 디지몬 시리즈 중에서 늑대의 이미지를 살린 디지몬이다.\n필살기는 입에서 내뿜는 고열의 푸른불꽃인 푸른 화염포 (폭스 파이어)다.",
      image: 가루몬,
    },
    가트몬: {
      title: "가트몬",
      desc: "성숙기의 성수형 디지몬.\n원판이름은 테일몬이다. 고양이의 모습을 한 디지몬으로 필살기는 자신의 상대방에게 주먹을 날리는 고양이 펀치다.\n호기심이 왕성하고 장난치는 것을 좋아한다. 몸집은 작지만 귀중한 신성계의 디지몬이며 외형과는 어울리지 않는 실력을 지니고 있다.",
      image: 가트몬,
    },
    도베르몬: {
      title: "도베르몬",
      desc: "원래는 바이러스종 디지몬이지만 돌연변이로 백신종이 된 헌터 디지몬.\n스나이몬과 마찬가지로, 백신종이라도 바이러스종 디지몬을 사냥하는 것만을 위해 존재하는 난폭한 디지몬이며 웬만한 테이머는 제어할 수 없다.\n필살기는 적의 능력을 봉인하는 포효 『그라우 레름』과 적의 몸을 꿰뚫어 디지코어를 파괴하는 검은 광선 『슈바르츠 ･ 슈트랄』이다.",
      image: 도베르몬,
    },
    레나몬: {
      title: "레나몬",
      desc: "금빛 여우의 모습을 한 수인형 디지몬.\n레나몬은 인간과의 관계가 그대로 드러나는 디지몬으로, 유년기 시절 육성 방법에 따라 특히 지능이 높은 레나몬으로 진화할 수 있다고 한다.\n항상 차분하고 침착하며 어떤 상황에서도 차분함을 잃지 않을 정도로 훈련되어 있다.",
      image: 레나몬,
    },
    쉬라몬: {
      title: "쉬라몬",
      desc: "육상에서 활동하는 것도 가능하게 되었고, 체온을 유지하는 모피로 몸을 덮은 바다짐승형 디지몬.\n몸을 가리는 흰 체모는 성장할수록 길어지고 갈색으로 변색된다고 한다. 성격은 보는것에는 모두 참견하고 싶어하는 참견쟁이.\n머리에 나 있는 붉은 털은 고마몬의 감정에 따라 움직이며 화가 나면 털이 거꾸로 선다.",
      image: 쉬라몬,
    },
    쉬몬: {
      title: "쉬라몬",
      desc: "육상에서 활동하는 것도 가능하게 되었고, 체온을 유지하는 모피로 몸을 덮은 바다짐승형 디지몬.\n몸을 가리는 흰 체모는 성장할수록 길어지고 갈색으로 변색된다고 한다. 성격은 보는것에는 모두 참견하고 싶어하는 참견쟁이.\n머리에 나 있는 붉은 털은 고마몬의 감정에 따라 움직이며 화가 나면 털이 거꾸로 선다.",
      image: 쉬라몬,
    },
    아구몬: {
      title: "아구몬",
      desc: "성장해 이족보행을 할 수 있게 된 공룡과 비슷한 모습을 한 파충류형 디지몬.\n비록 아직 성장 도중이라 힘은 약하지만 성격은 꽤 사납고 두려움을 모른다.\n 양손과 발에 단단하고 날카로운 손톱이 나있어 전투에서도 위력을 발휘한다.",
      image: 아구몬,
    },
    에테몬: {
      title: "에테몬",
      desc: `갑자기 디지털 월드에 나타난 정체불명의 디지몬.\n자칭 "킹 오브 디지몬"으로 전투력은 상상을 초월한다. 수수께끼의 디지몬 「퍼펫몬」을 배후에서 조종한다는 소문이 있다. 모든 공격을 견딜 수 있는 강화 원숭이 슈트를 입고 끝없는 싸움을 위해 오늘도 전 세계를 날아다닌다.`,
      image: 에테몬,
    },
    코로몬: {
      title: "코로몬",
      desc: "깜몬의 몸을 지키던 검은 솜털이 빠지고, 몸도 한 층 더 커진 소형 디지몬.\n활기차고 활발하게 움직이지만, 배틀은 아직 이르다. 하지만, 자라서 싸울 수 있게 되는 것은 시간 문제다. 깜몬과 마찬가지로, 입에서 산성 거품을 뿜어내 적을 위협한다.",
      image: 코로몬,
    },
    테리어몬: {
      title: "테리어몬",
      desc: `머리에 뿔 한개를 기른 수수께끼에 싸인 디지몬.\n매우 사랑스러운 타입의 디지몬으로 느긋한 행동에서 그다지 "전투종족"으로서의 디지몬을 실감할 수 없지만, 전투시에는 그 외형 이상의 파워를 발휘한다.`,
      image: 테리어몬,
    },
    토코몬: {
      title: "토코몬",
      desc: "몸(머리?)의 아래에 팔다리 같은 무언가가 자라난 소형 디지몬.\n팔다리가 난 유년기 디지몬은 비상히 희귀하며 보기에도 엄청나게 귀엽다. 하지만 귀엽다고 섣불리 다가가 손을 뻗으면, 돌연 입을 크게 벌려, 빽빽히 나 있는 송곳니에 물릴 수도 있으므로 신경써야 한다. 단, 성격은 순진무구하므로 악의는 없다.",
      image: 토코몬,
    },
    파닥몬: {
      title: "파닥몬",
      desc: "큰 귀가 특징적인 포유류형 디지몬.\n 이 큰 귀를 이용해 날 수 있지만, 시속 1KM의 속도밖에 나오지 않는 탓에 걷는 쪽이 빠르다. 그러나 필사적으로 날고 있는 모습이 귀엽기 때문에 인기는 높다.(본인은 납득하고 있지 않은 듯 하다.) 굉장히 솔직한 성격으로 가르친 것은 잘 지킨다.",
      image: 파닥몬,
    },
    플롯트몬: {
      title: "플롯트몬",
      desc: `늘어진 귀가 특징인 신성계 디지몬의 아이\n 아직 어린 탓에 그 신성한 힘을 발휘하지 못하고 자신의 사명도 모르고있다. 그 때문에 성질적으로 불안정하고, 선이나 악이 돼버린다. 그러나 신성계 디지몬으로 태어난 플롯트몬은 언젠가 "바이러스 버스터즈"로서의 사명에 눈뜰 때가 올 것이다.`,
      image: 플롯트몬,
    },
    피요몬: {
      title: "피요몬",
      desc: "날개의 부분이 팔처럼 발달되어 있는 병아리형 디지몬.\n날개를 손재주 있게 움직여 움직이는 물건을 잡을 수 있다. 그러나 하늘을 능숙하게 날 수는 없다.호기심이 왕성한 성격으로, 시드몬의 머리를 쪼아먹는 것을 좋아한다.",
      image: 피요몬,
    },
  };

  return obj[digimonName];
};

const handleCopyClipBoard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    Swal.fire("클립보드에 링크가 복사되었어요.");
  } catch (err) {
    console.log(err);
  }
};

const BASEURL = `https://snazzy-stardust-69c0a0.netlify.app/`;

export { getBase64, sleep, getDigimonInfo, handleCopyClipBoard, BASEURL };
